<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="80px" >
        <el-form-item label="用户名" ><!--最短四个字符-->
            <el-input v-model="form.username" ></el-input>
        </el-form-item>
        <el-form-item label="密码">
            <el-input show-password v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="Nickname" >
            <el-input v-model="form.Nickname" ></el-input>
        </el-form-item>
        <el-form-item label="手机号" >
            <el-input v-model="form.Mobile" ></el-input>
        </el-form-item>
        <el-form-item label="Email" >
            <el-input v-model="form.Email" ></el-input>
        </el-form-item>
       
        <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">创建</el-button>
            <!-- <el-button>取消</el-button> -->
        </el-form-item>
    </el-form>
</template>

<script>
import {AddUser} from '../../api/user'
export default {
    data() {
      return {
        form: {
          username: '',
          password: '',
          Nickname: '',
          Mobile: '',
          Email: ''
        
        },
        // rules表单验证
        rules: {
            password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
        }
      }
    },
    created() {
    //   this.getLoginInfo();
    },
  
    methods: {
        getLoginInfo(){
            let userinfo = JSON.parse(localStorage.getItem('userdata'));
            this.form.username = userinfo.username;
            // this.form.password = userinfo.password;
        },

      onSubmit(createData) {
        this.$refs[createData].validate(valid => {
        if (valid) {
            AddUser(this.form)
            .then(res => {
              if (res.code == 0) {
                this.clearForm();
                this.$message({
                  type: 'success',
                  message: '创建成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('创建失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
      },
      clearForm(){
        this.form.password = null;
        this.form.username = null;
        this.form.Nickname = null;
        this.form.Mobile = null;
        this.form.Email = null;
      }
    },  
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/system/addUser.vue